module.exports = ""


//////////////////
// WEBPACK FOOTER
// ./src/app/ships/ship-list/ship-list.component.sass
// module id = ./src/app/ships/ship-list/ship-list.component.sass
// module chunks = main